
/* Oct 20 (Jacob, meeting #59/#60): Holiday shop / BFCM page at /pages/holiday (view 'holiday'). Unlinked.
   The page changes itself by date (Mountain Time). Preview any phase with ?hp=pre|early|peak|after|late.
   EVERYTHING IN HOL BELOW IS A PLACEHOLDER UNTIL JACOB/TAMI CONFIRM: dates, %s, the peak code, the gift line.
   The %s here are only words. The real discounts must be created in Shopify to match. */
(function(){
  var HOL={
    saleStart:'2026-11-12T07:00:00Z', /* Nov 12 00:00 MT: ~15% automatic starts */
    peakStart:'2026-11-27T07:00:00Z', /* Black Friday 2026 is Nov 27 (Thanksgiving Nov 26) */
    peakEnd:'2026-12-01T07:00:00Z',   /* end of Cyber Monday, Nov 30 */
    cutEast:'2026-12-15T07:00:00Z',   /* order by end of Dec 14 MT */
    cutWest:'2026-12-18T07:00:00Z',   /* order by end of Dec 17 MT */
    basePct:15, peakPct:30,
    peakCode:'',                      /* TODO: the real BFCM code. Empty = "taken off at checkout" */
    gift:''                           /* TODO: e.g. "Plus 2 free rings with every order." Empty = not shown */
  };
  var V=window.__VMAP=window.__VMAP||{};V.misc=V.misc||{};
  var M={'holiday ring collection':47869464936667,'holiday oil collection':48107530879195,'holiday ring + oil combo':48107530911963,'holiday sanctuary set':48107530944731};
  for(var k in M)V.misc[k]=M[k];
  window.holScroll=function(id){var e=document.getElementById(id);if(e)e.scrollIntoView({behavior:'smooth'})};
  window.holCopy=function(){var v=HOL.peakCode;try{navigator.clipboard.writeText(v)}catch(e){}var b=document.querySelector('#view-holiday .hol-code .cc-link');if(b){b.textContent='Copied';setTimeout(function(){b.textContent='Copy code'},1600)}};
  function T(s){return Date.parse(s)}
  function phase(){
    var q=(location.search.match(/[?&]hp=(pre|early|peak|after|late)/)||[])[1];if(q)return q;
    var n=Date.now();
    if(n<T(HOL.saleStart))return 'pre';
    if(n<T(HOL.peakStart))return 'early';
    if(n<T(HOL.peakEnd))return 'peak';
    if(n<T(HOL.cutWest))return 'after';
    return 'late';
  }
  function g(){return HOL.gift?' '+HOL.gift:''}
  function copy(p){
    var codeTxt=HOL.peakCode?'Use code '+HOL.peakCode+' at checkout.':'Taken off at checkout.';
    var C={
      pre:{eyebrow:'The holiday shop',big:'Holiday gift sets are here.',sub:'Our holiday sale starts November 12.',countLabel:'Sale starts in',to:HOL.saleStart},
      early:{eyebrow:'The holiday sale is on',big:HOL.basePct+'% off everything',sub:'Taken off at checkout, no code needed.'+g(),countLabel:'Black Friday deals start in',to:HOL.peakStart},
      peak:{eyebrow:'Black Friday through Cyber Monday',big:HOL.peakPct+'% off everything',sub:codeTxt+g(),countLabel:'Ends in',to:HOL.peakEnd,code:!!HOL.peakCode},
      after:{eyebrow:'Still time to gift',big:HOL.basePct+'% off everything',sub:'Order by Dec 14 (East Coast) or Dec 17 (West Coast) to get it there by the 25th.'+g(),countLabel:Date.now()<T(HOL.cutEast)?'East Coast cutoff in':'West Coast cutoff in',to:Date.now()<T(HOL.cutEast)?HOL.cutEast:HOL.cutWest},
      late:{eyebrow:'Gifts for the new year',big:HOL.basePct+'% off everything',sub:'Holiday shipping cutoffs have passed, so new orders may arrive after the 25th.',countLabel:'',to:null,shipNote:'Holiday cutoffs have passed. Orders still ship every business day.'}
    };
    return C[p];
  }
  var root,cur=null,target=null,timer=null;
  function pad(n){return (n<10?'0':'')+n}
  function tick(){
    var w=root.querySelector('.hol-count-wrap');var ms=target?target-Date.now():0;
    if(!target||ms<=0){w.hidden=true;return}
    w.hidden=false;var t=Math.floor(ms/1000);
    w.querySelector('[data-hc="d"]').textContent=pad(Math.floor(t/86400));
    w.querySelector('[data-hc="h"]').textContent=pad(Math.floor(t%86400/3600));
    w.querySelector('[data-hc="m"]').textContent=pad(Math.floor(t%3600/60));
    w.querySelector('[data-hc="s"]').textContent=pad(t%60);
  }
  function paint(){
    root=document.getElementById('view-holiday');if(!root)return;
    var p=phase(),c=copy(p);root.setAttribute('data-phase',p);
    root.querySelectorAll('[data-hol-t]').forEach(function(e){var k=e.getAttribute('data-hol-t');if(c[k]!=null)e.textContent=c[k]});
    var code=root.querySelector('.hol-code');code.hidden=!c.code;if(c.code)code.querySelector('.hol-code-v').textContent=HOL.peakCode;
    target=c.to?T(c.to):null;tick();cur=p;
  }
  function stock(){
    fetch('/products/essence-holiday-gift-bundles.js').then(function(r){return r.ok?r.json():null}).then(function(j){
      var av={};if(j&&j.variants)j.variants.forEach(function(v){av[v.id]=v.available});
      root.querySelectorAll('.hol-add').forEach(function(b){
        var id=+b.getAttribute('data-hol-vid'),p=parseFloat(b.getAttribute('data-hol-price'));
        if(av[id]){b.disabled=false;b.textContent='Add to cart · $'+p.toFixed(2);b.onclick=function(){if(typeof quickAdd==='function')quickAdd(b.getAttribute('data-hol-name'),p)}}
        else{b.disabled=true;b.textContent='Coming soon';b.onclick=null}
      });
    }).catch(function(){});
  }
  var was=false;
  setInterval(function(){
    var on=window.current==='holiday';
    if(on&&!was){paint();stock();if(!timer)timer=setInterval(function(){if(phase()!==cur)paint();else tick()},1000)}
    if(!on&&was&&timer){clearInterval(timer);timer=null}
    was=on;
  },400);
})();
